import GuardiansMapFrame from "@/features/map/GuardiansMapFrame"

export default function MapTab() {
  return (
    <div className="px-2 py-4">
      <h1 className="px-2 text-xl font-semibold text-guardians-accent">Карта</h1>
      <p className="px-2 pb-2 text-xs text-guardians-muted">
        Сканы, банк, почта, лавки, боссы, клады и другие POI — как в приложении.
      </p>
      <GuardiansMapFrame />
    </div>
  )
}
